import store from '@/vuex';
export const getSurveyCommitId = () => {
  const obj = uni.getStorageSync('surveyCommitObj') || {};
  return obj[store.state.skinTestCoupon.survey.id] || '';
};
export const setSurveyCommitId = (val) => {
  const obj = uni.getStorageSync('surveyCommitObj') || {};
  obj[store.state.skinTestCoupon.survey.id] = val;
  uni.setStorageSync('surveyCommitObj', obj);
};
